module.exports = __webpack_public_path__ + "img/swiper10.e2cc51dc.png";